import { AdminExpertNoInterviewsTable } from './AdminExpertNoInterviewsTable';

export default AdminExpertNoInterviewsTable;